/**
 * 路由配置文件
 * 懒加载: const Foo = () => import('./Foo.vue')
 * 嵌套路由：https://router.vuejs.org/zh/guide/essentials/nested-routes.html
 * 编程式导航：https://router.vuejs.org/zh/guide/essentials/navigation.html
 * 路由元信息：https://router.vuejs.org/zh/guide/advanced/meta.html
 */

import Vue from 'vue'
import Router from 'vue-router'

// const Collections = () => import(/* webpackChunkName: "group-test" */ '@/pages/test/Collections')

const Dashboard = () => import(/* webpackChunkName: "group-general" */ '@/pages/general/Dashboard')
const Settings = () => import(/* webpackChunkName: "group-general" */ '@/pages/general/Settings')

const tradeIndustry = () => import(/* webpackChunkName: "group-good" */ '@/pages/versionTwo/tradeIndustry')
const industryInformation = () => import(/* webpackChunkName: "group-good" */ '@/pages/versionTwo/industryInformation')

const Goods = () => import(/* webpackChunkName: "group-good" */ '@/pages/good/Goods')
const Group = () => import(/* webpackChunkName: "group-good" */ '@/pages/good/Group')
const Records = () => import(/* webpackChunkName: "group-good" */ '@/pages/good/Records')
const Warehouses = () => import(/* webpackChunkName: "group-good" */ '@/pages/good/Warehouses')

const OrdersAll = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersAll')
const OrdersSend = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersSend')
const OrdersWaiting = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersWaiting')
const OrdersWaitingCross = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersWaitingCross')
const OrdersPayment = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersPayment')
const OrdersCart = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersCart')
const OrdersFinish = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersFinish')
const OrdersFail = () => import(/* webpackChunkName: "group-order" */ '@/pages/order/OrdersFail')

const Brands = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Brands')
const Categories = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Categories')
const Countries = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Countries')
const InformationCates = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/InformationCates')
const Information = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Information')
const Sliders = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Sliders')
const Activity = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Activity')
const singleGood = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/singleGood')
const Special = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Special')
const Voucher = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Voucher')
// const Freight = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/Freight')
const FreightTemplate = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/FreightTemplate')
const restrictedArea = () => import(/* webpackChunkName: "group-shop" */ '@/pages/shop/restrictedArea')

const pinOrdersAll = () => import(/* webpackChunkName: "group-order" */ '@/pages/pinOrder/pinOrdersAll')
const pinOrdersSend = () => import(/* webpackChunkName: "group-order" */ '@/pages/pinOrder/pinOrdersSend')
const pinOrdersWaiting = () => import(/* webpackChunkName: "group-order" */ '@/pages/pinOrder/pinOrdersWaiting')
const pinOrdersPayment = () => import(/* webpackChunkName: "group-order" */ '@/pages/pinOrder/pinOrdersPayment')
const pinOrdersCart = () => import(/* webpackChunkName: "group-order" */ '@/pages/pinOrder/pinOrdersCart')
const pinOrdersFinish = () => import(/* webpackChunkName: "group-order" */ '@/pages/pinOrder/pinOrdersFinish')
const pinOrdersFail = () => import(/* webpackChunkName: "group-order" */ '@/pages/pinOrder/pinOrdersFail')
const pinOrdersFailure = () => import(/* webpackChunkName: "group-order" */ '@/pages/pinOrder/pinOrdersFailure')

const ServiceFinish = () => import(/* webpackChunkName: "group-user" */ '@/pages/user/ServiceFinish')
const ServiceInit = () => import(/* webpackChunkName: "group-user" */ '@/pages/user/ServiceInit')
const ServiceReject = () => import(/* webpackChunkName: "group-user" */ '@/pages/user/ServiceReject')
const ServiceSend = () => import(/* webpackChunkName: "group-user" */ '@/pages/user/ServiceSend')
const ServiceWaiting = () => import(/* webpackChunkName: "group-user" */ '@/pages/user/ServiceWaiting')
const Users = () => import(/* webpackChunkName: "group-user" */ '@/pages/user/Users')
const appletCode = () => import(/* webpackChunkName: "group-user" */ '@/pages/appletCode/appletCode')

const branches = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/branches')
const salesOverview = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/salesOverview')
const personnel = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/personnel')
const checkPending = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/checkPending')
const commission = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/commission')
const cashWithdrawn = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/cashWithdrawn')
const taskCheckPending = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/taskCheckPending')
const task = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/task')
const clerkCouppon = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/clerkCouppon')
const bindCouppon = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/bindCouppon')
const recordCouppon = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/recordCouppon')
const test = () => import(/* webpackChunkName: "group-user" */ '@/pages/fenxiao/test')

Vue.use(Router)

export default new Router({
  routes: [
    // { path: '/', name: 'Collections', component: Collections },
    { path: '/', name: 'Dashboard', component: Dashboard },
    { path: '/settings', name: 'Settings', component: Settings },
    { path: '/tradeIndustry', name: 'tradeIndustry', component: tradeIndustry },
    { path: '/industryInformation', name: 'industryInformation', component: industryInformation },
    { path: '/goods', name: 'Goods', component: Goods },
    { path: '/group', name: 'Group', component: Group },
    { path: '/records', name: 'Records', component: Records },
    { path: '/warehouses', name: 'Warehouses', component: Warehouses },
    { path: '/ordersAll', name: 'OrdersAll', component: OrdersAll },
    { path: '/ordersSend', name: 'OrdersSend', component: OrdersSend },
    { path: '/ordersWaiting', name: 'OrdersWaiting', component: OrdersWaiting },
    { path: '/ordersPayment', name: 'OrdersPayment', component: OrdersPayment },
    { path: '/ordersCart', name: 'OrdersCart', component: OrdersCart },
    { path: '/ordersFinish', name: 'OrdersFinish', component: OrdersFinish },
    { path: '/ordersFail', name: 'OrdersFail', component: OrdersFail },
    { path: '/brands', name: 'Brands', component: Brands },
    { path: '/categories', name: 'Categories', component: Categories },
    { path: '/countries', name: 'Countries', component: Countries },
    { path: '/InformationCates', name: 'InformationCates', component: InformationCates },
    { path: '/Information', name: 'Information', component: Information },
    { path: '/sliders', name: 'Sliders', component: Sliders },
    { path: '/activity', name: 'Activity', component: Activity },
    { path: '/singleGood', name: 'singleGood', component: singleGood },
    { path: '/special', name: 'Special', component: Special },
    { path: '/voucher', name: 'Voucher', component: Voucher },
    // { path: '/Freight', name: 'Freight', component: Freight },
    { path: '/FreightTemplate', name: 'FreightTemplate', component: FreightTemplate },
    { path: '/restrictedArea', name: 'restrictedArea', component: restrictedArea },
    { path: '/pinOrdersAll', name: 'pinOrdersAll', component: pinOrdersAll },
    { path: '/pinOrdersSend', name: 'pinOrdersSend', component: pinOrdersSend },
    { path: '/pinOrdersWaiting', name: 'pinOrdersWaiting', component: pinOrdersWaiting },
    { path: '/OrdersWaitingCross', name: 'OrdersWaitingCross', component: OrdersWaitingCross },
    { path: '/pinOrdersPayment', name: 'pinOrdersPayment', component: pinOrdersPayment },
    { path: '/pinOrdersCart', name: 'pinOrdersCart', component: pinOrdersCart },
    { path: '/pinOrdersFinish', name: 'pinOrdersFinish', component: pinOrdersFinish },
    { path: '/pinOrdersFail', name: 'pinOrdersFail', component: pinOrdersFail },
    { path: '/pinOrdersFailure', name: 'pinOrdersFailure', component: pinOrdersFailure },
    { path: '/serviceFinish', name: 'ServiceFinish', component: ServiceFinish },
    { path: '/serviceInit', name: 'ServiceInit', component: ServiceInit },
    { path: '/serviceReject', name: 'ServiceReject', component: ServiceReject },
    { path: '/serviceSend', name: 'ServiceSend', component: ServiceSend },
    { path: '/serviceWaiting', name: 'ServiceWaiting', component: ServiceWaiting },
    { path: '/users', name: 'Users', component: Users },
    { path: '/appletCode', name: 'appletCode', component: appletCode },
    { path: '/branches', name: 'branches', component: branches },
    { path: '/salesOverview', name: 'salesOverview', component: salesOverview },
    { path: '/personnel', name: 'personnel', component: personnel },
    { path: '/checkPending', name: 'checkPending', component: checkPending },
    { path: '/commission', name: 'commission', component: commission },
    {path: '/cashWithdrawn', name: 'cashWithdrawn', component: cashWithdrawn},
    { path: '/task', name: 'task', component: task },
    { path: '/clerkCouppon', name: 'clerkCouppon', component: clerkCouppon },
    { path: '/bindCouppon', name: 'bindCouppon', component: bindCouppon },
    { path: '/taskCheckPending', name: 'taskCheckPending', component: taskCheckPending },
    { path: '/recordCouppon', name: 'recordCouppon', component: recordCouppon },
    { path: '/test', name: 'test', component: test }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js